import { GetStaticProps, InferGetStaticPropsType } from "next";

import { AppShell } from "@chef/feature-app-shell";
import {
  ContentComponent,
  ISection,
  SanityQuery,
  getSectionData,
  useSectionData,
} from "@chef/feature-sanity";
import { BRAND_PATHS } from "@chef/constants";
import { GiftCardOrderForm } from "../../components/GiftcardOrderForm";

export const GiftCardOrderPage = ({
  giftcardDescriptionTop,
  howDoesAGiftcardWorks,
}: InferGetStaticPropsType<typeof GiftCardOrderPageStaticProps>) => {
  const [giftcardDescriptionTopData] = useSectionData(giftcardDescriptionTop);
  const [howDoesAGiftcardWorksData] = useSectionData(howDoesAGiftcardWorks);

  const title =
    giftcardDescriptionTopData?.content.seo.title ||
    howDoesAGiftcardWorksData?.content.seo.title ||
    "";

  const description =
    giftcardDescriptionTopData?.content.seo.description ||
    howDoesAGiftcardWorksData?.content.seo.description ||
    "";

  return (
    <AppShell
      title={title}
      description={description}
      canonical={BRAND_PATHS.CANONICAL_GIFTCARD_URL}
    >
      <AppShell.Meta />
      <AppShell.Header />
      <AppShell.Main>
        {giftcardDescriptionTopData && (
          <ContentComponent block={giftcardDescriptionTopData?.content} />
        )}
        <GiftCardOrderForm
          howDoesAGiftcardWorksData={howDoesAGiftcardWorksData}
        />
      </AppShell.Main>
      <AppShell.Footer />
      <AppShell.TabBar />
    </AppShell>
  );
};

export const GiftCardOrderPageStaticProps: GetStaticProps<
  {
    draftMode: boolean;
    giftcardDescriptionTop: ISection;
    howDoesAGiftcardWorks: ISection;
  },
  SanityQuery
> = async ({ draftMode = false }) => {
  const [giftcardTop, giftcardSide] = await Promise.all([
    getSectionData("giftcard_description_top", { preview: draftMode }),
    getSectionData("how_does_a_giftcard_works", {
      preview: draftMode,
    }),
  ]);

  return {
    props: {
      draftMode,
      giftcardDescriptionTop: giftcardTop || null,
      howDoesAGiftcardWorks: giftcardSide || null,
    },
    revalidate: 600,
  };
};
